import React from 'react';
import AbstractInput from './abstract-input';
import './form.scss';

export default class FormSelect extends AbstractInput {
  render() {
    const { id, label, styleType, autoFocus, onFocus, onBlur, disabled, inputRef, selectStyle } = this.props;
    const { value, error, focus } = this.state;
    const styleTypeClass = styleType ?? 'compact';
    return (
      <div className={`form__block-${styleTypeClass}`}>
        <div className={`form__field-${styleTypeClass}`}>
          <select
            id={id}
            className={`form__input-${styleTypeClass} form__select ${
              !this.isEmpty(value)
                ? error && error.length > 0
                  ? ` form__input-${styleTypeClass}-error`
                  : ` form__input-${styleTypeClass}-success`
                : ''
            }`}
            value={value}
            placeholder={' '}
            onFocus={() => {
              if (onFocus) onFocus();
              this.focus();
            }}
            onBlur={() => {
              if (onBlur) onBlur();
              this.blur();
            }}
            onChange={this.update}
            autoFocus={autoFocus}
            disabled={disabled}
            ref={inputRef}
            style={selectStyle}
          >
            {this.props.children}
          </select>

          <label htmlFor={id} className={`form__label-${styleTypeClass}`}>
            {label}
          </label>
        </div>
        {!focus && error && error.length > 0 && (
          <span className={`form__block-${styleTypeClass}-error`}>
            <img src="/image/error-icon.png" alt="Error" />
            {error}
          </span>
        )}
      </div>
    );
  }
}

FormSelect.defaultProps = {
  ...AbstractInput.defaultProps,
  valueAttribute: (target) => target.options[target.selectedIndex].value,
  selectStyle: {}
};
